import { ChonkyFileBrowser } from '@centerpiece/components';
import { Container } from '@mui/material';

export const ProjectFilesTab = ({ id }: { id: number }) => {
  return (
    <Container
      maxWidth={'xl'}
      sx={{
        height: '90%',
        overflowY: 'hidden',
        // borderRadius: '4px',
        // border: theme => `1px solid ${theme.palette.divider}`,
        // backgroundColor: `rgba(0, 0, 0, 0.05)`,
        my: 'auto',
        py: 1,
      }}
    >
      <ChonkyFileBrowser id={id} />
    </Container>
  );
};
